
import { defineComponent, onBeforeMount, reactive } from 'vue'

// components
import TheInput from '@/common/components/UI/TheInput/index.vue'
import TheSelect from '@/common/components/UI/TheSelect/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'

//
import { DataState } from '@/core/classes/DataState.class'

//
import { CityT } from '@/core/types/cities.types'

//
import { cities } from '@/core/realisations/cities.realisation'

export default defineComponent({
    components: {
        'the-input': TheInput,
        'the-select': TheSelect,
        'the-button': TheButton,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['reset', 'search'],
    setup(props, { emit }) {
        const state = reactive({
            name: null as string | null,
            cityId: null as number | null,
        })

        const data_state = reactive({
            cities: new DataState<CityT>({}),
        })

        const reset = () => {
            state.name = null

            emit('reset')
        }

        const search = () => {
            emit('search', {
                name: state.name,
                cityId: state.cityId,
            })
        }

        const loadCities = async (page: number, search?: string) => {
            data_state.cities.pagination.current_page = page

            try {
                data_state.cities.is_loading = true

                const data = await cities.getAllList(page, search)
                data_state.cities.list = data.data

                data_state.cities.pagination.total_pages = data.meta.last_page

                data_state.cities.is_failed = false
                data_state.cities.failure.error_state.is_cancel = false
            } catch (error) {
                data_state.cities.failure.catchError(error)

                if (!data_state.cities.failure.error_state.is_cancel) {
                    data_state.cities.is_failed = true
                }
            } finally {
                if (!data_state.cities.failure.error_state.is_cancel) {
                    data_state.cities.is_loading = false
                }
            }
        }

        const loadMoreCities = async (page: number) => {
            if (page > data_state.cities.pagination.total_pages) return
            data_state.cities.pagination.current_page = page

            try {
                data_state.cities.is_loading = true

                const response = await cities.getAllList(page)
                data_state.cities.list = data_state.cities.list.concat(response.data)

                data_state.cities.pagination.total_pages = response.meta.last_page

                data_state.cities.is_failed = false
                data_state.cities.failure.error_state.is_cancel = false
            } catch (error) {
                data_state.cities.failure.catchError(error)

                if (!data_state.cities.failure.error_state.is_cancel) {
                    data_state.cities.is_failed = true
                }
            } finally {
                if (!data_state.cities.failure.error_state.is_cancel) {
                    data_state.cities.is_loading = false
                }
            }
        }

        const searchCity = (search_query: string) => {
            // data_state.cities.pagination.current_page
            loadCities(1, search_query)
        }

        const unshiftFindedCity = async (city: CityT) => {
            await loadCities(data_state.cities.pagination.current_page)
            data_state.cities.list.unshift(city)
        }

        onBeforeMount(() => {
            loadCities(1)
        })

        return {
            state,
            data_state,
            reset,
            search,
            loadCities,
            loadMoreCities,
            searchCity,
            unshiftFindedCity,
        }
    },
})
